import { type BubbleDO, type ComparativeBubbleApiResponse } from "../../data/bubble.data";
import { type StablecoinLatestDO } from "../../data/pie-chart.data";

function slugifySeriesLabel(label: string): string {
    return label
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '');
}

class BubbleTransform {

    public defiTradfiTVLtoBubbleDO(data: any): BubbleDO {
        // Transform the raw data to BubbleDO format
        return data as BubbleDO;
    }

    /**
     * comparative_bubble API: series[] + data[timestamp] = [[val0], [val1], …] aligned to series.
     */
    public comparativeBubbleToBubbleDO(raw: ComparativeBubbleApiResponse): BubbleDO {
        const bubbleData: BubbleDO = {};
        const series = raw.series;
        const dataByTime = raw.data;
        if (!series?.length || !dataByTime || typeof dataByTime !== 'object') {
            return bubbleData;
        }

        const timestamps = Object.keys(dataByTime).sort();
        const latestTs = timestamps[timestamps.length - 1];
        const rows = dataByTime[latestTs];
        if (!Array.isArray(rows)) {
            return bubbleData;
        }

        for (let i = 0; i < series.length; i++) {
            const label = series[i];
            const cell = rows[i];
            const n = Array.isArray(cell) && cell.length > 0 ? Number(cell[0]) : NaN;
            if (typeof n !== 'number' || Number.isNaN(n)) {
                continue;
            }
            const key = slugifySeriesLabel(label) || `series_${i}`;
            bubbleData[key] = {
                value: n,
                type: label
            };
        }

        return bubbleData;
    }

    public stablecoinVsBanksToBubbleDO(data: StablecoinLatestDO): BubbleDO {
        // Transform stablecoin vs banks data to bubble format
        const bubbleData: BubbleDO = {};
        
        if (data.stablecoin_vs_banks) {
            Object.entries(data.stablecoin_vs_banks).forEach(([key, value]) => {
                bubbleData[key] = {
                    value: (value as { value: number }).value,
                    type: (value as { type: string }).type
                }   
            });
        }
        
        return bubbleData;
    }
}

export const bubbleTransform = new BubbleTransform()